import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper/index';
import './styles.css';
import ScrollLoader from '../../components/scroll-loader';

/**
 *  BodySize
 */
class BodySize extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    modelName: PropTypes.string,
    modelNameJa: PropTypes.string,
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    notice: PropTypes.string,
    bodySize: PropTypes.string,
    bodyTypeModel: PropTypes.string,
    specSummary: PropTypes.shape({
      //passengers: PropTypes.array,
      minLength: PropTypes.string,
      maxLength: PropTypes.string,
      minWidth: PropTypes.string,
      maxWidth: PropTypes.string,
      minHeight: PropTypes.string,
      maxHeight: PropTypes.string,
      minWeight: PropTypes.string,
      maxWeight: PropTypes.string,
      wheelBase: PropTypes.string,
      tireSizes: PropTypes.array,
    }),
    //modelName: PropTypes.string,
    //bodyTypeModel: PropTypes.string,
    carTypeCode: PropTypes.string,
    gradeId: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    description: null,
    mbDescription: null,
    notice: null,
    bodySize: null,
    bodyTypeModel: null,
    specSummary: null,
    imageDirectory: null,
    modelNameJa: null,
    modelName: null,
    //bodyTypeModel: null,
    carTypeCode: null,
    gradeId: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      isMounted: false,
    }
  }
  
  componentDidMount() {
    this.setState({
      isMounted: true,
    })
  };
  
  componentWillUnmount() {
    this.setState({
      isMounted: false,
    })
  }
  
  render() {
    
    // タイトル・詳細
    const renderDescription = ()=> {
      const getPcDescription = ()=> {
        if (this.props.description && this.props.description !== '') {
          return this.props.description;
        } else {
          return '';
        }
      };
      const getMbDescription = ()=> {
        if (this.props.mbDescription && this.props.mbDescription !== '') {
          return this.props.mbDescription;
        } else {
          return getPcDescription();
        }
      };
      return (
        <div className="BodySize__description">
          <div className="BodySize__description__text-pc Wysiwyg"
               dangerouslySetInnerHTML={{__html: (getPcDescription() !== null) ? getPcDescription() : ''}}
          />
          <div className="BodySize__description__text-mb Wysiwyg"
               dangerouslySetInnerHTML={{__html: (getMbDescription() !== null) ? getMbDescription() : ''}}
          />
        </div>
      )
    };
    
    // 画像
    const renderImage = ()=> {
      const getImageDirectory = (modelName = null, bodyTypeModel = null, carTypeCode = null, gradeId = null) => {
        if (modelName && bodyTypeModel && carTypeCode && gradeId) {
          let str = '';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            str = '/assets-dev/assets/cars/';
          } else {
            str = '/globalassets/assets/cars/';
          }
          str = str + modelName + '/';
          str = str + bodyTypeModel + '/';
          str = str + carTypeCode + '/';
          //str = str + gradeId + '/';
          str = str + 'common/';
          str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
          return str;
        } else {
          return null;
        }
      };
      if (this.state.isMounted === true) {
        const imageDirectory = getImageDirectory(this.props.modelName, this.props.bodyTypeModel, this.props.carTypeCode, this.props.gradeId);
        if (imageDirectory) {
          return (
            <div className="BodySize__image">
              <img className="BodySize__image__image-pc"
                   src={imageDirectory + 'bodysize_pc.png'}
              />
              <img className="BodySize__image__image-mb"
                   src={imageDirectory + 'bodysize_mb.png'}
              />
            </div>
          )
        } else {
          return null;
        }
      } else {
        return null
      }
    };
    
    // 注釈
    const renderNotice = ()=> {
      if (this.props.notice && this.props.notice !== '') {
        return (
          <div className="BodySize__notice Wysiwyg"
               dangerouslySetInnerHTML={{__html: (this.props.notice !== null) ? this.props.notice : ''}}
          />
        )
      } else {
        return null;
      }
    };
    
    // モデル名称
    // const renderModelName = ()=> {
    //   if (this.props.modelName && this.props.modelName !== '') {
    //     return (
    //       <div className="BodySize__model-name">{this.props.modelName}</div>
    //     )
    //   } else {
    //     return null;
    //   }
    // };
    
    // スペック詳細
    const renderSpecSummary = ()=> {
      const getSpecText = (min, max)=> {
        if (min && min !== '' && max && max !== '' ) {
          if (min === max) {
            return Number(min).toLocaleString();
          } else {
            return Number(min).toLocaleString() + '〜' + Number(max).toLocaleString();
          }
        } else if (min && min !== '') {
          return Number(min).toLocaleString();
        } else if (max && max !== '') {
          return Number(max).toLocaleString();
        } else {
          return null;
        }
      };
      
      const getPassengersText = (arr)=> {
        if (arr && arr instanceof Array && 1 <= arr.length) {
          if (arr.length === 1) {
            return arr[0];
          } else {
            return arr.join(' | ');
          }
        } else {
          return null;
        }
      };
      
      //
      if (this.props.specSummary && this.props.specSummary !== '') {
        const length = getSpecText(this.props.specSummary.minLength, this.props.specSummary.maxLength);
        const width = getSpecText(this.props.specSummary.minWidth, this.props.specSummary.maxWidth);
        const height = getSpecText(this.props.specSummary.minHeight, this.props.specSummary.maxHeight);
        const wheelBase = getSpecText(this.props.specSummary.wheelBase);
        const passengers = getPassengersText(this.props.specSummary.passengers);
        const weight = getSpecText(this.props.specSummary.minWeight, this.props.specSummary.maxWeight);
        const thStyle = {textAlign: 'left', padding: '10px'};
        const tdStyle = {textAlign: 'left', color: '#101010', padding: '10px'};
        return (
          <div className="Wysiwyg">
            <table style={{width: '100%'}} border="0">
              <tbody>
              {(length && length !== '') ?
                <tr>
                  <th style={thStyle}>全長(mm)</th>
                  <td style={tdStyle}>{length}</td>
                </tr>
                : null}
              {(width && width !== '') ?
                <tr>
                  <th style={thStyle}>全幅(mm)</th>
                  <td style={tdStyle}>{width}</td>
                </tr>
                : null}
              {(height && height !== '') ?
                <tr>
                  <th style={thStyle}>全高(mm)</th>
                  <td style={tdStyle}>{height}</td>
                </tr>
                : null}
              {(wheelBase && wheelBase !== '') ?
                <tr>
                  <th style={thStyle}>ホイールベース(mm)</th>
                  <td style={tdStyle}>{wheelBase}</td>
                </tr>
                : null}
              {(passengers && passengers !== '') ?
                <tr>
                  <th style={thStyle}>乗車定員(名)</th>
                  <td style={tdStyle}>{passengers}</td>
                </tr>
                : null}
              {(weight && weight !== '') ?
                <tr>
                  <th style={thStyle}>車両重量(kg)</th>
                  <td style={tdStyle}>{weight}</td>
                </tr>
                : null}
              {(this.props.specSummary.tireSizes && this.props.specSummary.tireSizes !== '') ?
                <tr>
                  <th style={thStyle}>タイヤサイズ</th>
                  <td style={tdStyle}>
                    {this.props.specSummary.tireSizes.map((size, index)=> {
                      return (
                        <div key={index}>{size}</div>
                      )
                    })}
                  </td>
                </tr>
                : null}
              </tbody>
            </table>
          </div>
        )
      } else {
        return (
          <div className="BodySize__spec-summary Wysiwyg"
               dangerouslySetInnerHTML={{__html: (this.props.bodySize !== null) ? this.props.bodySize : ''}}
          />
        );
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <ScrollLoader>
          <div className="BodySize">
            <div className="BodySize__container">
              
              {renderDescription()}
              
              {/*{renderModelName()}*/}
              
              <div className="BodySize__box">
                <div className="BodySize__box-right">
                  
                  {renderImage()}
                  
                </div>
                <div className="BodySize__box-left">
                  
                  {renderSpecSummary()}
                  
                
                </div>
              </div>
              
              {renderNotice()}
              
            </div>
          </div>
        </ScrollLoader>
      </Wrapper>
    )
  }
  
}

export default BodySize;



// WEBPACK FOOTER //
// ./src/containers/body-size/index.jsx